export default {
    init() {
      
		/**
		* Zapusti urejanje restavracije
		**/
		$('#zapusti_urejanje_restavracije').on('click', function(e) {
			e.preventDefault()
			$(this).text('Preusmerjam...')
			$.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				data: {
					action: 'zapusti_urejanje_restavracije'
				},
				dataType: 'json',
				success: function (response) {
					console.log(response)
					if (response && response.success && response.data && response.data.redirect_url) {
						window.location.href = response.data.redirect_url
					}
				}
			})
		})

    }
}